const MaterialData = {
  data: [
    // Printed PVC Doors Sheet
    {
      title: "ZD001 Digital Printed PVC Doors Sheet",
      color: "Green (Base)",
      material: "PVC",
      size: "22x78 Inch (WxL)",
      thickness: "3mm",
      category: "material_home_door",
      img: "../assets/material/image1.png",
      description: [
        { title: "Weatherproof Door Material", note: "3mm thick PVC sheet with weather-resistant properties, ensuring durability in various conditions." },
        { title: "Vibrant Green Base Design", note: "Green base color with a digital printed pattern and glossy finish for a visually appealing door surface." },
        { title: "Standard Door Size", note: "22x78 inch (WxL) rectangular shape, designed to fit common door frames, and easily identifiable with code ZD001." },
      ]
    },
    {
      title: "ZD002 Digital Printed PVC Doors Sheet",
      color: "Brown and White (Base)",
      material: "PVC",
      size: "	22x78 Inch (WxL)",
      thickness: "4mm",
      category: "material_home_door",
      img: "../assets/material/image2.png",
      description: [
        {
          title: "Robust Door Construction",
          note: "4mm thick PVC sheet ensures durability and weather resistance for long-lasting door panels."
        },
        {
          title: "Modern Aesthetic",
          note: "Brown and white base with a glossy digital print offers a contemporary and visually appealing door surface."
        },
        {
          title: "Standard Door Fit",
          note: "22x78 inch (WxL) rectangular dimensions, designed for common door frame sizes, and easily identified by code ZD002."
        },
      ]
    },
    {
      title: "ZD003 Digital Printed PVC Doors Sheet",
      color: "White and Brown (Base)",
      material: "PVC",
      size: "22x78 Inch (WxL)",
      thickness: "3mm",
      category: "material_extra_door",
      img: "../assets/material/image3.png",
      description: [
        {
          title: "Durable and Weatherproof",
          note: "3mm thick PVC sheet with weather-resistant properties, ideal for long-lasting door panels."
        },
        {
          title: "Aesthetic Digital Print",
          note: " White and brown base with a glossy finish and digital printed pattern, adding a stylish touch to doors."
        },
        {
          title: "Standard Door Dimensions",
          note: "22x78 inch (WxL) rectangular shape, designed for common door frames, and easily identifiable with code ZD003."
        },
      ]
    },
    {
      title: "ZD008 Digital Printed PVC Doors Sheet",
      color: "White and Black (Base)",
      material: "PVC",
      size: "22x78 Inch (WxL)",
      thickness: "4mm",
      category: "material_extra_door",
      img: "../assets/material/image5.png",
      description: [
        {
          title: "Weather-Resistant Door Panels",
          note: "4mm thick PVC sheet with weather-proof properties, ideal for durable door construction."
        },
        {
          title: "Modern Digital Print Design",
          note: "White and black base with a digital printed pattern and glossy finish, offering a contemporary aesthetic."
        },
        {
          title: "Standard Door Dimensions",
          note: "22x78 inch (WxL) rectangular shape, designed for common door sizes, with easy identification via ZD008 code."
        },
      ]
    },
    // Digital PVC Hollow Sheet
    {
      title: "Zeaco ZH05 Digital PVC Hollow Sheet",
      color: "Brown",
      material: "PVC",
      size: "6 Feet",
      thickness: "10mm",
      category: "material_home_digital",
      img: "../assets/material/image10.png",
      description: [
        {
          title: "Heavy-Duty Industrial Use",
          note: "10mm thick PVC hollow sheet designed for demanding industrial environments."
        },
        {
          title: "Practical Brown Color",
          note: "Brown color and plain pattern offer a versatile and functional surface for industrial applications."
        },
        {
          title: "Standard Length and Identification",
          note: "6-foot length and ZH05 code for easy ordering and consistent product specification."
        },
      ]
    },
    {
      title: "Zeaco ZH05 Digital PVC Hollow Sheet",
      color: "Grey",
      material: "PVC",
      size: "8 Feet",
      thickness: "10mm",
      category: "material_home_digital",
      img: "../assets/material/image16.png",
      description: [
        {
          title: "Heavy-Duty Industrial Grade",
          note: "10mm thick PVC hollow sheet designed for demanding industrial applications."
        },
        {
          title: "Large Format Coverage",
          note: "8-foot length provides efficient coverage for extensive industrial projects."
        },
        {
          title: "Easy Identification and Ordering",
          note: "ZH05 code ensures accurate product selection and procurement."
        },
      ]
    },
    {
      title: "Zeaco ZH07 Digital PVC Hollow Sheet",
      color: "Carbon Black",
      material: "PVC",
      size: "8 Feet",
      thickness: "10mm",
      category: "material_extra_digital",
      img: "../assets/material/image14.png",
      description: [
        {
          title: "Robust Industrial Material",
          note: "10mm thick PVC hollow sheet designed for durable industrial applications."
        },
        {
          title: "Large Format Coverage",
          note: "8-foot length provides efficient coverage for large areas or projects."
        },
        {
          title: "Identifiable Product Specification",
          note: "ZH07 product code ensures easy ordering and consistent product quality from Zeaco."
        },
      ]
    },
    {
      title: "Zeaco ZH07 Digital PVC Hollow Sheet",
      color: "Shadow gray",
      material: "PVC",
      size: "8 Feet",
      thickness: "10mm",
      category: "material_extra_digital",
      img: "../assets/material/image13.png",
      description: [
        {
          title: "Industrial-Strength Construction",
          note: "10mm thick PVC hollow sheet provides robust durability for industrial applications."
        },
        {
          title: "Large-Scale Application",
          note: " 8-foot length allows for efficient coverage of extensive areas or projects."
        },
        {
          title: "Clear Product Identification",
          note: "ZH07 code ensures easy ordering and consistent product specification from Zeaco."
        },
      ]
    },
    {
      title: "Zeaco ZH013 Digital PVC Hollow Sheet",
      color: "Brown",
      material: "PVC",
      size: "6 Feet",
      thickness: "10mm",
      category: "material_extra_digital",
      img: "../assets/material/image17.png",
      description: [
        {
          title: "Robust Industrial Material",
          note: "10mm thick PVC hollow sheet designed for heavy-duty industrial applications."
        },
        {
          title: "Practical Brown Finish",
          note: "Brown color provides a versatile and functional surface for industrial settings."
        },
        {
          title: "Standard Size and Identification",
          note: "6-foot length and ZH13 code for easy ordering and consistent product specification."
        },
      ]
    },
    {
      title: "Zeaco ZH014 Digital PVC Hollow Sheet",
      color: "Printed gray",
      material: "PVC",
      size: "6 Feet",
      thickness: "10mm",
      category: "material_extra_digital",
      img: "../assets/material/image12.png",
      description: [
        {
          title: "Industrial-Strength with Aesthetic Appeal",
          note: "10mm thick PVC hollow sheet designed for industrial applications, but with a floral printed pattern for added visual interest."
        },
        {
          title: "Practical Gray Color",
          note: "Gray base color provides a neutral and adaptable backdrop for the floral print."
        },
        {
          title: "Standard Size and Identification",
          note: "6-foot length and ZH14 code for easy ordering and consistent product specification."
        },
      ]
    },
    {
      title: "Zeaco ZH015 Digital PVC Hollow Sheet",
      color: "Golden Black",
      material: "PVC",
      size: "8 Feet",
      thickness: "10mm",
      category: "material_extra_digital",
      img: "../assets/material/image15.png",
      description: [
        {
          title: "Industrial-Grade Strength",
          note: "10mm thick PVC hollow sheet designed for demanding industrial environments."
        },
        {
          title: "Large-Scale Application",
          note: "8-foot length enables efficient coverage for extensive projects."
        },
        {
          title: "Customizable Color Options",
          note: "Available in a range of colors beyond the standard, providing versatility for various industrial needs."
        },
      ]
    },
    {
      title: "Zeaco ZH016 Digital PVC Hollow Sheet",
      color: "White",
      material: "PVC",
      size: "8 Feet",
      thickness: "10mm",
      category: "material_extra_digital",
      img: "../assets/material/image11.png",
      description: [
        {
          title: "High-Durability Industrial Use",
          note: "10mm thick PVC hollow sheet engineered for demanding industrial environments."
        },
        {
          title: "Bright White Base",
          note: "White base color offers a clean and adaptable surface for various industrial applications."
        },
        {
          title: "Large-Format Coverage",
          note: "8-foot length provides efficient coverage for extensive projects and easy identification with code ZH16."
        },
      ]
    },
    //  Printed PVC Sheet
    {
      title: "Zeaco SK011 Printed PVC Sheet",
      color: "Chocolate Gold", // Color not specified in the image
      material: "PVC",
      size: "8 Feet",
      thickness: "5 mm",
      category: "material_home_printed",
      img: "../assets/material/image8.png",
      description: [
        {
          title: "Industrial-Grade Durability",
          note: "5mm thick PVC sheet designed for robust industrial applications."
        },
        {
          title: "Aesthetic Enhancement",
          note: "Printed pattern and glossy finish provide a visually appealing surface."
        },
        {
          title: "Extended Length & Identification",
          note: "8-foot length and SK011 code for easy ordering and large-scale applications."
        }
      ]
    },
    {
      title: "Zeaco SK013 Printed PVC Sheet",
      color: "Printed Black", // Color not specified
      material: "PVC",
      size: "8 Feet",
      thickness: "5 mm",
      category: "material_extra_printed",
      img: "../assets/material/image9.png",
      description: [
        {
          title: "Extended Length for Larger Applications",
          note: "8-foot length provides flexibility for larger furniture projects or installations."
        },
        {
          title: "Durable and Decorative",
          note: "5mm thick PVC sheet with a printed pattern and glossy finish, combining strength and aesthetics."
        },
        {
          title: "Identifiable Product Code",
          note: "SK013 code ensures easy ordering and product tracking."
        }
      ]
    },
    {
      title: "Zeaco SK017 Printed PVC Sheet",
      color: "Blue (Base)",
      material: "PVC",
      size: "6 Feet",
      thickness: "5 mm",
      category: "material_extra_printed",
      img: "../assets/material/image6.png",
      description: [
        {
          title: "Furniture Grade PVC",
          note: "5mm thick PVC sheet designed for furniture applications, ensuring durability."
        },
        {
          title: "Distinctive Printed Pattern",
          note: "Features a unique printed pattern with a blue base color, adding a stylish touch."
        },
        {
          title: "Standard Dimensions & Identification",
          note: "6-foot length and SK017 product code for easy ordering and specification. Also available in different colours."
        }
      ]
    },
    {
      title: "Zeaco SK019 Printed PVC Sheet",
      color: "wheat", // Color is not specified in the image
      material: "PVC",
      size: "6 Feet",
      thickness: "5 mm",
      category: "material_extra_printed",
      img: "../assets/material/image7.png",
      description: [
        {
          title: "Decorative Furniture Enhancement",
          note: "Printed pattern and glossy surface finish add aesthetic appeal to furniture applications."
        },
        {
          title: "Durable PVC Material",
          note: "5mm thick PVC sheet provides strength and longevity for furniture construction."
        },
        {
          title: "Standard Size & Code",
          note: "6-foot length and SK019 code for easy identification and ordering. Also available in different colours."
        }
      ]
    },
    // Extra Material
    {
      title: "UPVC Extruded Profile",
      color: "Off White",
      material: "UPVC",
      size: "8 Feet",
      category: "material_home_row",
      img: "../assets/material/image18.png",
      description: [
        {
          title: "Durable UPVC Material",
          note: "Constructed from 4mm thick UPVC, ensuring long-lasting performance and resistance to moisture."
        },
        {
          title: "Standard Length for Versatility",
          note: "8-foot length provides flexibility for various applications and installations."
        },
        {
          title: "Neutral Off-White Color",
          note: "Off-white color offers a clean and adaptable aesthetic for diverse projects."
        }
      ]
    },
    {
      title: "Zeaco 2033 PVC Solid Square Rod",
      color: "Black",
      material: "PVC",
      size: "200 mm",
      category: "material_extra_row",
      img: "../assets/material/image19.png",
      description: [
        {
          title: "High Tensile Strength",
          note: "75 MPa tensile strength, indicating a robust and durable PVC rod."
        },
        {
          title: "Compact and Solid",
          note: "200mm length and solid square shape, suitable for various industrial and DIY applications."
        },
        {
          title: "Durable Black PVC",
          note: "Black PVC material, offering resistance to weathering and chemicals, and easily identifiable by the 2033 series and Zeaco brand."
        }
      ]
    },
    {
      title: "Zeaco 1719 PVC Solid Square Rod",
      color: "Black",
      material: "PVC",
      size: "300 mm",
      category: "material_extra_row",
      img: "../assets/material/image20.png",
      description: [
        {
          title: "Durable PVC Construction",
          note: "Solid square rod made from high-quality PVC for reliable performance."
        },
        {
          title: "Moderate Tensile Strength",
          note: "60 MPa tensile strength, suitable for a range of applications."
        },
        {
          title: "Standard Length and Identification",
          note: "300mm length, black color, and 1719 series for easy ordering and specification."
        }
      ]
    },
    {
      title: "PVC Wall Panel",
      color: "White",
      material: "PVC",
      size: "10 Feet x 10 Inch",
      thickness: "6 mm",
      category: "material_extra_row",
      img: "../assets/material/image21.png",
      description: [
        {
          title: "Moisture-Resistant Design",
          note: "Safe for use in wet environments like kitchens, bathrooms, and freezers due to its PVC material."
        },
        {
          title: "Durable 6mm Thickness",
          note: "Provides a sturdy and long-lasting wall covering solution."
        },
        {
          title: "Standard Size and Color",
          note: "10 feet x 10 inches dimensions and white color make it versatile for various interior designs."
        }
      ]
    },

  ],
  furniture: [
    {
      title: "Furniture PVC Sheet 1",
      color: "White",
      size: ["22x78 Inch (WxL)", "22x96 Inch (WxL)", "25x78 Inch (WxL)"],
      category: "material_home_furniture",
      img: "../assets/material/image25.jpeg",
    },
    {
      title: "Furniture PVC Sheet 2",
      color: "Black",
      size: ["22x78 Inch (WxL)", "22x96 Inch (WxL)", "25x78 Inch (WxL)"],
      category: "material_home_furniture",
      img: "../assets/material/image24.jpeg",
    },
    {
      title: "Furniture PVC Sheet 3",
      color: "Golden White",
      size: ["22x78 Inch (WxL)", "22x96 Inch (WxL)", "25x78 Inch (WxL)"],
      category: "material_extra_furniture",
      img: "../assets/material/image23.jpeg",
    },
    {
      title: "Furniture PVC Sheet 4",
      color: "Lining White",
      size: ["22x78 Inch (WxL)", "22x96 Inch (WxL)", "25x78 Inch (WxL)"],
      category: "material_extra_furniture",
      img: "../assets/material/image22.jpeg",
    },
  ]
}

export default MaterialData